<template>
  <draggable
    v-model="internalValue"
    class="row"
    ghost-class="sortable-ghost"
    chosen-class="sortable-chosen"
    drag-class="sortable-drag"
    @input="change"
  >
    <template v-for="(instruction, index) in internalValue">
      <v-col
        :key="`instruction-${instruction.order}`"
        cols="12"
        sm="6"
        lg="4"
      >
        <v-card>
          <v-toolbar
            color="primary"
            dark
            flat
            dense
          >
            <v-row align="center" justify="space-between">
              <v-col cols="auto">
                <v-toolbar-title v-text="index + 1" />
              </v-col>
              <v-col cols="auto">
                <v-btn icon small @click="remove(instruction)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-toolbar>

          <v-img
            :src="`${imageSrcBase}${company.id}/${instruction.src}`"
            height="250"
            contain
            class="grey lighten-2"
          />
        </v-card>
      </v-col>
    </template>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import Config from 'src/config'
import Helpers from 'src/utils/helpers'

export default {
  name: 'InstructionList',
  components: {
    draggable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    internalValue: [],
  }),
  computed: {
    ...mapGetters('me', {
      company: 'company',
    }),
    imageSrcBase () {
      return `${Config.API_URL}networkDiagram/instruction/`
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.internalValue = Helpers.clone(value)
      },
    },
  },
  methods: {
    remove (instruction) {
      this.internalValue = this.internalValue.filter(item => item !== instruction)
      this.change()
    },
    change () {
      this.$emit('input', this.internalValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.sortable-ghost {
  opacity: 0.5;
}
</style>
